

















import { listFactory } from '@/main/pages';
import { previewButton } from '@/main/utils/tableOperations';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';

import { NAME } from './constants';
import { store } from './store/list';

export default listFactory(NAME, store).extend({
	methods: {
		viewDetailsClick(e: any, cells: any) {
			openEdit(NAME, PageMode.EDIT, { props: true, id: cells[this.table.cellNames!.ID], OrderId: cells[this.table.cellNames!.ORDER_NO] });
		},
	},
	computed: {
		extraButtons(): {} {
			return { ...previewButton(this.viewDetailsClick) };
		},
	},
});
